import { useContext } from 'react';

import { Button } from '@/components/Button/Button';
import { RichText } from '@/components/RichText/RichText';
// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';

const Alert = () => {
	const [state, dispatch] = useContext(Context);

	const handleClose = () => {
		dispatch({
			type: ActionTypes.hideError
		});
	};

	const message = state.alertMessage?.includes('{{userEmail}}')
		? state.alertMessage.replace('{{userEmail}}', state.user.email || '')
		: state.alertMessage;

	return (
		<div className="alert dialog dialog-width345" hidden={state.hideAlert} role="alert">
			<section
				aria-labelledby="dialog-discard-title"
				aria-modal="true"
				className="dialog--surface"
				role="dialog"
			>
				{state?.alertTitle ? (
					<h1 className="dialog--title" id="dialog-discard-title">
						{state.alertTitle}
					</h1>
				) : null}
				{message ? (
					<p>
						<RichText
							components={{ link: state.alertLink ? <a href={state.alertLink} /> : undefined }}
							message={message}
						/>
					</p>
				) : null}

				<div className="dialog--actions">
					<Button
						ariaLabel="Schließen"
						className="form--button form--button-secondary form--button-small"
						onClick={handleClose}
						type="button"
					>
						Okay
					</Button>
				</div>
			</section>
			<div className="dialog--backdrop"></div>
		</div>
	);
};

export { Alert };
